import { render, staticRenderFns } from "./DeutschlandCardPoints.vue?vue&type=template&id=6aa9458a&scoped=true"
import script from "./DeutschlandCardPoints.vue?vue&type=script&lang=js"
export * from "./DeutschlandCardPoints.vue?vue&type=script&lang=js"
import style0 from "./DeutschlandCardPoints.vue?vue&type=style&index=0&id=6aa9458a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9458a",
  null
  
)

export default component.exports